// extracted by mini-css-extract-plugin
export default {"container":"Differences_container__ggSHr","title":"Differences_title__pDvLU","titleBlue":"Differences_titleBlue__EmT1Y"};